<template>
    <answers ref="answers"
             code_question_group="GQ23"
             danger_code="MCAL11"
    />
</template>

<script>
import answers from '../../../components/answers.vue';

export default {
    name: 'index',
    components: {
        answers
    }
};
</script>
